// src/Common/Layout/ConfirmationModal.js

import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "primary",
  iconClass = "ri-question-line"
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center p-4">
        <div className="mb-3">
          <i className={`${iconClass} display-4 text-${confirmVariant}`}></i>
        </div>
        <h4 className="mb-2">{title}</h4>
        <p className="text-muted mb-4">{message}</p>
        <div className="d-flex justify-content-center gap-2">
          <Button variant="light" onClick={handleClose}>
            {cancelText}
          </Button>
          <Button variant={confirmVariant} onClick={handleConfirm}>
            {confirmText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;